'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scroll = require('./scroll.scss');

var _scroll2 = _interopRequireDefault(_scroll);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _scroll3 = require('redux/modules/scroll');

var scrollActions = _interopRequireWildcard(_scroll3);

var _vm = require('vm');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scroll = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    currentLanguage: state.language.lang,
    nextLanguage: state.language.nextLang,
    carouselScroll: state.scroll.carouselScroll,
    positionScroll: state.scroll.positionScroll
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, scrollActions), dispatch);
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Scroll, _React$Component);

  function Scroll(props) {
    (0, _classCallCheck3.default)(this, Scroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Scroll.__proto__ || (0, _getPrototypeOf2.default)(Scroll)).call(this, props));

    _this.state = {
      top: 0,
      touchStart: null,
      duration: 1000,
      animation: false
    };
    _this.eventName = null;
    _this.navigateScroll = _this.navigateScroll.bind(_this);
    _this.getIncrement = _this.getIncrement.bind(_this);
    _this.scrollTo = _this.scrollTo.bind(_this);
    _this.reload = _this.reload.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Scroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.sections = (0, _from2.default)(document.querySelector(".content").childNodes);
      this.scrollWindow = window.pageYOffset;

      document.addEventListener('wheel', this.navigateScroll);
      document.addEventListener('touchstart', function () {
        _this2.setState({ touchStart: event.touches[0].clientY });
      });
      document.addEventListener('touchmove', this.navigateScroll);
      var isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
      this.eventName = isOnIOS ? "pagehide" : "beforeunload";
      window.addEventListener(this.eventName, this.reload);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      document.removeEventListener('wheel', this.navigateScroll);
      document.removeEventListener('touchstart', function () {
        _this3.setState({ touchStart: event.touches[0].clientY });
      });
      document.removeEventListener('touchmove', this.navigateScroll);
      window.removeEventListener(this.eventName, this.reload);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.carouselScroll > 0) {
        return true;
      }
      return false;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.navigateScroll();
    }
  }, {
    key: 'reload',
    value: function reload() {
      window.focus();
      window.scrollTo(0, 0);
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo() {
      var _this4 = this;

      var offsetTop = this.sections[this.props.positionScroll].offsetTop;
      this.setState({ animation: true });
      $('html,body').animate({ scrollTop: offsetTop }, { duration: this.state.duration, complete: function complete() {
          _this4.setState({ animation: false });
        } });
    }
  }, {
    key: 'getIncrement',
    value: function getIncrement(value) {
      var result = 0;
      if (this.props.carouselScroll === -1) {
        value > 0 ? result++ : result--;
      }
      return result;
    }
  }, {
    key: 'navigateScroll',
    value: function navigateScroll() {
      var _this5 = this;

      if (!this.state.animation && this.props.carouselScroll !== 0) {
        switch (this.props.carouselScroll) {
          case -1:
            var increment = void 0;
            if (event.deltaY) {
              increment = this.getIncrement(event.deltaY);
            } else if (event.changedTouches) {
              console.log(event.changedTouches);
              increment = this.getIncrement(this.state.touchStart - event.changedTouches[0].clientY);
            };
            if (this.props.positionScroll + increment <= this.sections.length - 2 && this.props.positionScroll + increment >= 0) {
              this.props.setPositionScroll(this.props.positionScroll + increment);
              this.scrollTo();
            };
            break;
          case 1:
            this.props.setPositionScroll(this.sections.length - 3);
            setTimeout(function () {
              _this5.scrollTo();
              _this5.props.setCarouselScroll(-1);
              document.addEventListener('wheel', _this5.navigateScroll);
            }, 100);
            break;
          case 2:
            this.scrollTo();
            this.props.setCarouselScroll(-1);
            break;
          default:
            return false;
        }
        if (this.props.positionScroll == this.sections.length - 2 && this.props.carouselScroll != 1) {

          document.removeEventListener('wheel', this.navigateScroll);
          setTimeout(function () {
            _this5.props.setCarouselScroll(0);
          }, 1000);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { className: 'scroll' });
    }
  }]);
  return Scroll;
}(_react2.default.Component)) || _class);
exports.default = Scroll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Scroll/Scroll.jsx
// module id = 708
// module chunks = 0